import controller from './api-access.controller';

const template = require('./api-access.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/developer-settings/api-access/api-access.component.js